import axios from 'axios';
import API_URL from '../utils/apiUrl';

export const getPublishedStories = async (featured = false) => {
  const params = featured ? { featured: 'true' } : {};
  const response = await axios.get(`${API_URL}/success-stories`, { params });
  return response.data.data;
};

export const getStoryById = async (id) => {
  const response = await axios.get(`${API_URL}/success-stories/${id}`);
  return response.data.data;
};

export const getAllStoriesAdmin = async () => {
  const response = await axios.get(`${API_URL}/success-stories/admin/all`);
  return response.data.data;
};

export const createStory = async (data) => {
  const response = await axios.post(`${API_URL}/success-stories`, data);
  return response.data.data;
};

export const updateStory = async (id, data) => {
  const response = await axios.put(`${API_URL}/success-stories/${id}`, data);
  return response.data.data;
};

export const deleteStory = async (id) => {
  await axios.delete(`${API_URL}/success-stories/${id}`);
};
